import { toast } from "react-toastify";

export const showSuccessToast = (name, message) => {
	toast.success(name, {
		data: {
			title: name,
			text: message,
		},
	});
};
